import type { PieceType } from './types';

export const MATERIAL: Record<PieceType, number> = { K: 100_000, R: 900, C: 460, H: 420, E: 220, A: 220, P: 100 };
export const INITIAL_NON_KING_MATERIAL = 2 * (
  2 * MATERIAL.R + 2 * MATERIAL.C + 2 * MATERIAL.H + 2 * MATERIAL.E + 2 * MATERIAL.A + 5 * MATERIAL.P
);
